var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"border mb-0",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"d-flex align-items-center p-1",class:_vm.center ? 'justify-content-center text-center' : ''},[_c('div',{style:({
        flex: _vm.center ? '0 1 auto' : '1 1 0%',
        minWidth: 0,
        overflow: 'hidden'
      })},[_c('h2',{staticClass:"mb-25 font-weight-bolder",style:({
          display: 'block',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        })},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{style:({
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        })},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.shortText)?[_vm._v(" ("),_c('short-text',{attrs:{"text":_vm.shortText}}),_vm._v(") ")]:_vm._e()],2)]),(!_vm.center)?_c('b-avatar',{style:({ flex: '0 0 auto' }),attrs:{"variant":['light', _vm.variant].join('-'),"size":"45"}},[_c('span',{staticClass:"material-icons-outlined"},[_vm._v(_vm._s(_vm.icon))])]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }